export default __webpack_public_path__ + "static/30_31-7a2048ee18de171d5b48366b28e7d0af.png";